import React from 'react';
import { useSnackbar } from 'notistack';
import { FeedBackNotification } from '@michelin/acid-components';
import { ShoppingCart } from '@material-ui/icons';


interface EnqueueMessagesParams {
  message: string;
  color?: 'success' | 'danger' | 'warning' | 'info';
  persist?: boolean;
  icon?: React.ReactElement;
}

export function useEnqueueSnackbar() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const enqueueMessages = ({
    message,
    persist,
    color,
  }: EnqueueMessagesParams) => 
      enqueueSnackbar(
        <FeedBackNotification
          onUpdate={() => closeSnackbar()}
          notification={{
            message: {
            subject: message,
          }}}
          color={color ?? 'info'}
          icon={<ShoppingCart />}
        />,
        {
          persist,
          autoHideDuration: 5000,
          preventDuplicate: true,
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'center',
          },
          ContentProps: {
            style: {
              background: 'transparent',
              boxShadow: 'none',
            },
          },
        }
      );

  return {
    enqueueMessages,
  };
}
